import { createRouter, createWebHistory } from "vue-router";
import { autodetectCountryCode } from "@/services/translation";
import { Layout } from "@/router/types";
import { checkVersion, handleInvalidTokenFound, handleLogin, handleRedirectForLoggedInUser, setLinkAlternate, setUserPreferredLocalization, startupUserCheck, storeLocalizationInApp } from "@/router/guards";
import { RouteName } from "@/router/routeNameEnum";
import { routes } from "@/router/routes";
import { handleMrSharkCampaignRedirect } from "@/router/helpers";
import { UrlAnchor } from "@/composables";

const router = createRouter({
  history: createWebHistory("/"),
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      redirect: () => {
        const countryCode = autodetectCountryCode();
        return "/" + countryCode;
      },
    },
    {
      path: "/facebook-sso-callback",
      components: { mainContent: () => import("@/views/auth/FacebookSsoCallback.vue") },
      name: RouteName.FacebookSsoCallback,
      meta: {
        public: true,
        layout: Layout.LockingState,
        allowNoCountryCode: true,
      },
    },
    {
      path: "/ai-identification:catchRest(.*)",
      redirect: (to) => {
        const redirectUrl = handleMrSharkCampaignRedirect(to);
        if (redirectUrl === undefined) {
          const countryCode = autodetectCountryCode();
          return {
            path: `${countryCode}/colectio-ai${to.params.catchRest || ""}`,
            query: to.query,
            hash: to.hash,
          };
        } else {
          return redirectUrl;
        }
      },
    },
    {
      path: "/soutez",
      redirect: "/cz/soutez",
    },
    {
      path: "/:countryCode(cz|sk)",
      children: routes,
    },
  ],
  scrollBehavior(to, from) {
    const isSameRouteName = to.name === from.name;

    const galleryHash = "#" + UrlAnchor.OpenGallery;
    const isGalleryToggle = to.hash === galleryHash || from.hash === galleryHash;

    if (isSameRouteName && isGalleryToggle) {
      return false; // Do not scroll when open or close gallery
    }

    if (to.hash && document.getElementById(to.hash.slice(1))) {
      return { el: to.hash };
    }

    if (isSameRouteName && to.meta.preventScrollToTop === true) {
      return;
    }

    return { top: 0 };
  },
});

router.beforeEach(startupUserCheck);
router.beforeEach(checkVersion);
router.beforeEach(storeLocalizationInApp);
router.beforeEach(handleInvalidTokenFound);
router.beforeEach(setUserPreferredLocalization);
router.beforeEach(handleLogin);
router.beforeEach(handleRedirectForLoggedInUser);

router.afterEach(setLinkAlternate);

export { router };
